import { RouteLocationNormalizedLoaded, RouteRecordRaw } from 'vue-router';
import Layout from '@/components/layout/index.vue';
import Welcome from '@/pages/welcome/index.vue';
import Login from '@/pages/login/index.vue';
import { useLayoutStore } from '@/store';

function getProps(route: RouteLocationNormalizedLoaded) {
  return route.query;
}

// 系统生成路由
export const routers: Array<RouteRecordRaw> = [
  {
    path: '/login',
    component: Login,
    name: 'login',
    meta: {
      title: '登录',
    },
  },
  {
    path: '/',
    component: Layout,
    name: 'main',
    props: getProps,
    redirect: {
      name: 'welcome',
    },
    meta: {
      title: '主页',
      showOnly: true,
    },
    children: [
      {
        path: 'welcome',
        component: Welcome,
        name: 'welcome',
        meta: { title: '欢迎', keepalive: false },
      },
      {
        path: 'formSysMenu',
        component: () =>
          useLayoutStore().supportColumn
            ? import('@/pages/upms/formSysMenu/formSysColumnMenu.vue')
            : import('@/pages/upms/formSysMenu/index.vue'),
        name: 'formSysMenu',
        meta: { title: '菜单列表', keepalive: true },
      },
      {
        path: 'formSysUser',
        component: () => import('@/pages/upms/formSysUser/index.vue'),
        name: 'formSysUser',
        meta: { title: '用户列表', keepalive: true },
      },
      {
        path: 'formSysDept',
        component: () => import('@/pages/upms/formSysDept/index.vue'),
        name: 'formSysDept',
        meta: { title: '部门列表', keepalive: true },
      },
      {
        path: 'formSysRole',
        component: () => import('@/pages/upms/formSysRole/index.vue'),
        name: 'formSysRole',
        meta: { title: '角色管理', keepalive: true },
      },
      {
        path: 'formSysDataPerm',
        component: () => import('@/pages/upms/formSysDataPerm/index.vue'),
        name: 'formSysDataPerm',
        meta: { title: '数据权限管理', keepalive: true },
      },
      {
        path: 'formSysLoginUser',
        component: () => import('@/pages/upms/formSysLoginUser/index.vue'),
        name: 'formSysLoginUser',
        meta: { title: '在线用户', keepalive: true },
      },
      {
        path: 'formSysDict',
        component: () => import('@/pages/upms/formSysDict/index.vue'),
        name: 'formSysDict',
        meta: { title: '字典管理', keepalive: true },
      },
      {
        path: 'formSysOperationLog',
        component: () => import('@/pages/upms/formSysOperationLog/index.vue'),
        name: 'formSysOperationLog',
        meta: { title: '操作日志', keepalive: true },
      },
      // 404
      {
        path: '/:pathMatch(.*)*',
        component: () => import('@/pages/error/404.vue'),
        name: 'NotFound',
        meta: {
          title: '404',
        },
      },
      {
        path: 'formMemberInfo',
        component: () => import('@/pages/member/formMemberManagement.vue'),
        name: 'formMemberInfo',
        props: getProps,
        meta: { title: '会员管理', keepalive: true },
      },
      {
        path: 'formSubscriptionPlan',
        component: () => import('@/pages/member/formSubscriptionPlan.vue'),
        name: 'formSubscriptionPlan',
        props: getProps,
        meta: { title: '订阅管理', keepalive: true },
      },
      {
        path: 'formMemberEquity',
        component: () => import('@/pages/member/formMemberEquity.vue'),
        name: 'formMemberEquity',
        props: getProps,
        meta: { title: '会员权益', keepalive: true },
      },
      {
        path: 'memberEquityDetail/:id',
        component: () => import('@/pages/member/formEditMemberEquity.vue'),
        name: 'memberEquityDetail',
        props: getProps,
        meta: { title: '权益详情', keepalive: false },
      },
      {
        path: 'formMemberEquityPackage',
        component: () => import('@/pages/member/formMemberEquityPackage.vue'),
        name: 'formMemberEquityPackage',
        props: getProps,
        meta: { title: '权益包管理', keepalive: true },
      },
      {
        path: 'formEditMemberEquityPackage',
        component: () => import('@/pages/member/formEditMemberEquityPackage.vue'),
        name: 'formEditMemberEquityPackage',
        props: getProps,
        meta: { title: '权益包编辑', keepalive: false },
      },
      {
        path: 'formMemberEquityMetadata',
        component: () => import('@/pages/member/formMemberEquityMetadata.vue'),
        name: 'formMemberEquityMetadata',
        props: getProps,
        meta: { title: '会员权益模版', keepalive: false },
      },
      {
        path: 'maintenance',
        component: () => import('@/pages/materialManager/maintenance.vue'),
        name: 'maintenance',
        props: getProps,
        meta: { title: '素材维护', keepalive: true },
      },
      {
        path: 'metadataTemplates',
        component: () => import('@/pages/materialManager/metadataTemplates.vue'),
        name: 'metadataTemplates',
        props: getProps,
        meta: { title: '数据模板管理', keepalive: true },
      },
      {
        path: 'formPlanOrder',
        component: () => import('@/pages/order/formPlanOrder.vue'),
        name: 'formPlanOrder',
        props: getProps,
        meta: { title: '计划订单', keepalive: true },
      },
      {
        path: 'formRefundOrder',
        component: () => import('@/pages/order/formPlanOrder.vue'),
        name: 'formRefundOrder',
        props: getProps,
        meta: { title: '退款订单', keepalive: true },
      },
      {
        path: 'formOrderDetail',
        component: () => import('@/pages/order/formOrderDetail.vue'),
        name: 'formOrderDetail',
        props: getProps,
        meta: { title: '订单详情', keepalive: true },
      },
      {
        path: 'formDmensionConfig',
        component: () => import('@/pages/auralSkillGauge/formDmensionConfig.vue'),
        name: 'formDmensionConfig',
        props: getProps,
        meta: { title: '等级评估权重', keepalive: true },
      },
      {
        path: 'formLevelThresholds',
        component: () => import('@/pages/auralSkillGauge/formLevelThresholds.vue'),
        name: 'formLevelThresholds',
        props: getProps,
        meta: { title: '等级评估阈值', keepalive: true },
      },
      {
        path: 'formOverallEvaluationTemplates',
        component: () => import('@/pages/auralSkillGauge/formOverallEvaluationTemplates.vue'),
        name: 'formOverallEvaluationTemplates',
        props: getProps,
        meta: { title: '综合评估报告模版', keepalive: true },
      },
      {
        path: 'formReportTemplates',
        component: () => import('@/pages/auralSkillGauge/formReportTemplates.vue'),
        name: 'formReportTemplates',
        props: getProps,
        meta: { title: '详细报告模板', keepalive: true },
      },
      {
        path: 'templateList',
        component: () => import('@/pages/questionTemplate/templateList.vue'),
        name: 'templateList',
        props: getProps,
        meta: { title: '模板列表', keepalive: true },
      },
      {
        path: 'quoTempEdit',
        component: () => import('@/pages/questionTemplate/quoTempEdit.vue'),
        name: 'quoTempEdit',
        props: getProps,
        meta: { title: '模板维护', keepalive: true },
      },
      {
        path: 'levelParameter',
        component: () => import('@/pages/questionTemplate/levelParameter.vue'),
        name: 'levelParameter',
        props: getProps,
        meta: { title: '等级参数配置', keepalive: true },
      },
      {
        path: 'progressList',
        component: () => import('@/pages/auralSkillGauge/progressList/index.vue'),
        name: 'progressList',
        props: getProps,
        meta: { title: '进度管理列表', keepalive: true },
      },
      {
        path: 'testProgressDetail',
        component: () =>
          import('@/pages/auralSkillGauge/progressList/components/TestProgressDetail.vue'),
        name: 'TestProgressDetail',
        props: getProps,
        meta: { title: '听觉测试详情', keepalive: false },
      },
      {
        path: 'trainingProgressDetail',
        component: () =>
          import('@/pages/auralSkillGauge/progressList/components/TrainingProgressDetail.vue'),
        name: 'TrainingProgressDetail',
        props: getProps,
        meta: { title: '听觉训练详情', keepalive: false },
      },
      {
        path: 'screeningProgressDetail',
        component: () =>
          import('@/pages/auralSkillGauge/progressList/components/ScreeningProgressDetail.vue'),
        name: 'ScreeningProgressDetail',
        props: getProps,
        meta: { title: '一键筛查详情', keepalive: false },
      },
      {
        path: 'pureToneProgressDetail',
        component: () =>
          import('@/pages/auralSkillGauge/progressList/components/PureToneProgressDetail.vue'),
        name: 'PureToneProgressDetail',
        props: getProps,
        meta: { title: '纯音测听详情', keepalive: false },
      },
      {
        path: 'questionNaire',
        component: () => import('@/pages/questionNaire/questionNaire.vue'),
        name: 'questionNaire',
        props: getProps,
        meta: {title: '调查问卷管理', keepalive: true}
      },
      {
        path: 'questionList',
        component: () => import('@/pages/questionNaire/questionList.vue'),
        name: 'questionList',
        props: getProps,
        meta: {title: '题目管理', keepalive: true}
      },
      {
        path: 'memberQN',
        component: () => import('@/pages/questionNaire/memberQN.vue'),
        name: 'memberQN',
        props: getProps,
        meta: {title: '客户问卷明细', keepalive: true}
      },
    ],
  },
  // TODO 第三方接入路由
  {
    path: '/thirdParty',
    component: () => import('@/components/thirdParty/index.vue'),
    name: 'thirdParty',
    props: getProps,
    children: [
      // 通用
      {
        path: 'thirdSelectDept',
        name: 'thirdSelectDept',
        props: getProps,
        component: () => import('@/components/DeptSelect/DeptSelectDlg.vue'),
      },
      {
        path: 'thirdSelectUser',
        name: 'thirdSelectUser',
        props: getProps,
        component: () => import('@/components/UserSelect/UserSelectDlg.vue'),
      },
      {
        path: 'thirdTableCustomQuery',
        name: 'thirdTableCustomQuery',
        props: getProps,
        component: () => import('@/components/TableBox/CustomQuery/index.vue'),
      },
      {
        path: 'thirdTableCustomConfig',
        name: 'thirdTableCustomConfig',
        props: getProps,
        component: () => import('@/components/TableBox/CustomConfig/index.vue'),
      },
    ],
  },
];
